import {jobTypeCodes} from "@/enums/jobTypeCodes";

export const primitiveUserSettingCodes = {
  CPV3_DASHBOARD_GRID_LAYOUT: 'CPV3_DASHBOARD_GRID_LAYOUT',
  CP_IsMenuCollapsed: 'CP_IsMenuCollapsed',
  CPv3_OC_Detail: 'CPv3_OC_Detail',
  FrontEndDisclaimerAccepted: 'FrontEndDisclaimerAccepted'
}
